module.exports = __webpack_public_path__ + "static/img/74LS47-1.2bfdb8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/74LS47-1.svg
// module id = 9JoN
// module chunks = 0